module.exports = __webpack_public_path__ + "img/maskrcnnsf.08242401.png";